import React from 'react';

import { Typography } from '@mui/material';
import { makeStyles } from 'tss-react/mui';
import { Button } from '@uplift/ui-v2';

import {
  DownArrow, StepContainer, StepContent, StepContentBox, StepHeading, StepNavigator, StepNextButton
} from '../components';

export type UpNextConfigurableStepProps = {
  onBack?: () => void;
  onNext?: () => void;
  headerTitle?: string;
  headerHighlight?: string;
  contentTitle?: string;
  contentDescription?: string | React.ReactNode;
  nextButtonText?: string;
  secondaryButtonText?: string;
  onSecondaryClick?: () => void;
};

export const UpNextConfigurableStep: React.VFC<UpNextConfigurableStepProps> = ({
  onNext,
  headerTitle,
  headerHighlight,
  contentTitle,
  contentDescription,
  nextButtonText = 'Next',
  secondaryButtonText,
  onSecondaryClick,
}) => {
  const { classes } = useUpNextConfigurableStepStyles();

  return (
    <StepContainer className={classes.container}>
      <StepContent className={classes.contentContainer}>
        <StepHeading className={classes.header}>
          <div className={classes.arrow}>
            <DownArrow />
            <Typography className={classes.upNext} variant="overline">Up Next</Typography>
          </div>
          {headerTitle}&nbsp;
          <Typography component="span" variant="inherit" className={classes.secondaryMain}>
            {headerHighlight}
          </Typography>
        </StepHeading>
        <StepContentBox title={contentTitle} description={contentDescription} />
      </StepContent>
      <StepNavigator>
        <StepNextButton onClick={onNext}>{nextButtonText}</StepNextButton>
        {secondaryButtonText && (
          <Button color="secondary" onClick={onSecondaryClick}>{secondaryButtonText}</Button>
        )}
      </StepNavigator>
    </StepContainer>
  );
};

const useUpNextConfigurableStepStyles = makeStyles({ name: 'UpNextConfigurableStep' })((theme) => ({
  container: {
    background: theme.palette.beige.main,
    [theme.breakpoints.up('md')]: {
      background: 'unset',
    },
  },
  contentContainer: {
    paddingTop: 0,
  },
  upNext: {
    textTransform: 'uppercase',
    display: 'block',
    margin: theme.spacing(2, 0),
    fontSize: '12px',
    fontWeight: 700,
  },
  secondaryMain: {
    color: theme.palette.secondary.main,
  },
  header: {
    fontSize: '34px',
    marginBottom: theme.spacing(1),
  },
  arrow: {
    top: -1,
  },
}));
